import {Component} from '@angular/core';

@Component({
    selector: 'app-walkthrough-quickpay',
    templateUrl: './walkthrough-quickpay.component.html',
    styleUrls: ['../product-walkthrough.component.scss'],
    standalone: false
})
export class WalkthroughQuickpayComponent
{
}
